import moment from "moment-timezone";

/**
 * Formats a date range for display in a title format
 * Example: "Dec 15, 2:30–4:45 PM"
 */
export const formatDateRangeTitle = (
  startDateTime: string,
  endDateTime: string
): string => {
  const start = moment(startDateTime, "YYYY-MM-DDTHH:mm:ss");
  const end = moment(endDateTime, "YYYY-MM-DDTHH:mm:ss");

  return `${start.format("MMM D")}, ${start.format("h:mm")}–${end.format(
    "h:mm A"
  )}`;
};

/**
 * Formats a time range for display
 * Example: "2:30 PM - 4:45 PM"
 */
export const formatTimeRange = (
  startDateTime: string,
  endDateTime: string
): string => {
  const start = moment(startDateTime, "YYYY-MM-DDTHH:mm:ss");
  const end = moment(endDateTime, "YYYY-MM-DDTHH:mm:ss");

  return `${start.format("h:mm A")} - ${end.format("h:mm A")}`;
};

/**
 * Parses a date string and returns a moment object for display formatting
 */
export const formatDateTimeToDisplay = (dateTime: string): moment.Moment => {
  return moment(dateTime, "YYYY-MM-DDTHH:mm:ss");
};

/**
 * Formats a date for server submission
 * Example: "2024-01-15T14:30:00.000Z"
 */
export const formatDateTimeForServer = (dateTime: Date | string): string => {
  return moment(dateTime).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
};
